import axios from "axios";
import queryString, {ParseOptions} from "query-string";

import {AUTH_URL} from "@/utils/constants";
import {EXP, SA, UUID} from "./constants";

import _ from "lodash";
import dayjs, {Dayjs} from "dayjs";

import * as constants from "./constants";

export const iprgex =
    /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/gi;
export const ip6regx =
    /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/;
export const domainregx =
    /(?![\d.]+)((?!-))(xn--)?[a-z0-9][a-z0-9-_]{0,61}[a-z0-9]{0,1}\.(xn--)?([a-z0-9._-]{1,61}|[a-z0-9-]{1,30})/g;

Object.defineProperty(String.prototype, "toCapitalize", {
    value: function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
    },
    enumerable: false,
});

export const sleep = (ms: number) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export function logging(key: string = "|", data: any) {
    console.info(constants.APP_PACKAGE.version, key, data);
}

const queryStringFormats = {
    skipNull: true,
    arrayFormat: "bracket",
    skipEmptyString: true,
} as ParseOptions;

export function queryStringParse(queries: string) {
    return queryString.parse(queries, queryStringFormats);
}

export async function requestSimple(
    url: string,
    method: string = "GET",
    data = {},
    headers = {},
    options = {}
) {
    return axios({
        method: method,
        url: url,
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
            ...headers,
        },
        data: data,
        ...options,
    });
}

async function refreshToken() {
    return await requestSimple(
        AUTH_URL + "/auth/v2/refresh_token",
        "GET",
        {},
        {},
        {
            withCredentials: true,
        }
    )
        .then(({data}) => {
            if (data.errors) return undefined;

            const {access_token, exp} = data.data;

            if (access_token && exp) {
                localStorage.setItem(SA, access_token);
                localStorage.setItem(EXP, exp.toString());
            }

            return access_token;
        })
        .catch((error) => {
            console.log("refresh token failed with error: ", error);
        });
}

export async function requestWithToken(
    url: string,
    method: string = "GET",
    data = {},
    headers = {},
    options = {}
) {
    const accessTokenIsExpired =
        Date.now() / 1000 > Number(localStorage.getItem("EXP") || 0);

    const accessToken =
        accessTokenIsExpired && localStorage.getItem(SA)
            ? await refreshToken()
            : localStorage.getItem(SA);

    if (typeof accessToken === "undefined" || accessToken === null) {
        localStorage.removeItem(SA);
        localStorage.removeItem(EXP);
        localStorage.removeItem(UUID);
        // window.location.href = "/auth/login";
    }

    return requestSimple(
        url,
        method,
        data,
        {
            ...headers,
            Authorization: `Bearer ${accessToken}`,
        },
        options
    );
}

export const setToken = (access_token: string, exp: number, uuid: string) => {
    if (!access_token || !exp || !uuid) {
        console.error('setToken called with invalid parameters:', { access_token, exp, uuid });
        return;
    }
    localStorage.setItem(SA, access_token);
    localStorage.setItem(EXP, exp.toString());
    localStorage.setItem(UUID, uuid);
};

export const removeToken = () => {
    localStorage.removeItem(SA);
    localStorage.removeItem(EXP);
    localStorage.removeItem(UUID);
    localStorage.removeItem('recentServices');
};

export function getRandomInt(max: number) {
    return Math.floor(Math.random() * max);
}

export function resolveMinOfArray(array: [] | any = []) {
    return _.min(array) || 0;
}

export function resolveMaxOfArray(array: [] | any = []) {
    return _.max(array) || 0;
}

export function resolveSumOfArray(array: [] | any = []) {
    return _.sum(array) || 0;
}

export function formatVolumeUnit(value: number, multiply = 1000, digit = 2) {
    const unit = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB",
        "BB",
        "NB",
        "DB",
        "CB",
        "XB",
    ];
    let i = 0;

    while (value >= multiply) {
        value = value / multiply;
        ++i;
    }

    return (Math.round(value * 100) / 100).toFixed(digit) + " " + unit[i];
}

export function formatThousandUnit(value: number, digit = 0) {
    const unit = ["", "K", "M", "B", "E", "Z", "Y"];
    let i = 0;

    while (value >= 1000) {
        value = value / 1000;
        ++i;
    }

    return (Math.round(value * 100) / 100).toFixed(digit) + " " + unit[i];
}

export function formatBandwidthUnit(value: number, digit = 2) {
    const unit = [
        "bps",
        "Kbps",
        "Mbps",
        "Gbps",
        "Tbps",
        "Pbps",
        "Ebps",
        "Zbps",
        "Ybps",
        "Bbps",
        "Nbps",
        "Dbps",
        "Cbps",
        "Xbps",
    ];

    let i = 0;
    while (value > 1000) {
        value = value / 1000;
        ++i;
    }

    return (Math.round(value * 100) / 100).toFixed(digit || 2) + " " + unit[i];
}

export function formatDecimal(value: any) {
    if (value === "" || value === undefined) {
        return 0;
    }

    const decimals = 2;

    value = Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals);

    const parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return parts.join(".");
}

export function dateToString(date: Dayjs) {
    return dayjs(date)?.format("YYYY-MM-DDTHH:mm:00[Z]");
}

export function sumWithInitial(array: any = []) {
    return array.reduce(
        (accumulator: any, currentValue: any) => accumulator + currentValue,
        0
    );
}

export function formatDurationToClock(duration: any) {
    duration = parseInt(duration);

    let hours: any = Math.floor(duration / 3600);
    let minutes: any = Math.floor((duration - hours * 3600) / 60);
    let seconds: any = duration - hours * 3600 - minutes * 60;

    if (hours < 10) hours = "0" + hours;
    if (minutes < 10) minutes = "0" + minutes;
    if (seconds < 10) seconds = "0" + seconds;

    return hours + ":" + minutes + ":" + seconds;
}

export function resolveShortNameOfEmail(email: string) {
    return _.first(email?.split("@"))
        ?.split(".")
        ?.map((part: string) => part?.[0])
        ?.join("")
        ?.toUpperCase();
}

export function resolveHistoricTimeRange(
    query: { gte: Dayjs; lte: Dayjs },
    range: string
) {
    const {gte, lte} = query;

    console.log(gte, lte);

    switch (range) {
        case "7d":
            return {
                gte: dateToString(dayjs(gte).subtract(7, "days")),
                lte: gte,
            };
        case "30d":
            return {
                gte: dateToString(dayjs(gte).subtract(31, "days")),
                lte: gte,
            };
        default:
            return query;
    }
}

export function resolveListDaysByMonth(month: number, year: number) {
    const date = new Date(year, month, 1);
    const days = [];

    while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }

    return days;
}

export function copyTextToClipboard(text?: string, callback?: any) {
    if (text) {
        navigator.clipboard.writeText(text);
    }

    if (typeof callback !== "undefined") {
        callback();
    }
}

export function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function findTopOfArray(items: any[], key: string) {
    try {
        if (!items) return;

        return items?.reduce(function (prev, current) {
            return prev && prev[key] > current[key] ? prev : current;
        });
    } catch (exception) {
        return;
    }
}

export function generateRandomString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }

    return result;
}
